'use client';

import { useEffect } from 'react';

/**
 * @preserve
 * enterthe....
 * cryptobin.co/h5e494p8
 */
const asciiLogo = `
     @@@@@@     @@@@@@     
     @@@@@@     @@@@@@     
 @@@@@@@@@@@@@@@@@@@@@@@@@ 
@@@@@      @@@@@      @@@@@
@@@@@      @@@@@      @@@@@
      @@@@@@@@   @@@@@@@@  
     @@@@@@     @@@@@@     
     @@@@@@     @@@@@@     

hello friend
`;

export function AsciiLogoLoggerComponent() {
  useEffect(() => {
    console.log(asciiLogo);
  }, []);

  return null;
}
